import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import { PackageReturnsApiService } from './_services/packageReturns.api.service';

import { MutationTypes, ActionTypes } from './store.types';

export { namespace } from './store.types';

export default {
  namespaced: true,

  state: {
    packageReturns: [],
    packageReturn: {},
  },

  mutations: {
    [MutationTypes.SET_PACKAGE_RETURNS](state, payload) {
      state.packageReturns = payload;
    },

    [MutationTypes.SET_PACKAGE_RETURN](state, payload) {
      state.packageReturn = payload;
    },
  },

  actions: {
    async [ActionTypes.GET_PACKAGE_RETURNS](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, ...rest },
    ) {
      commit(
        MutationTypes.SET_PACKAGE_RETURNS,
        await PackageReturnsApiService.getPackageReturns({ suffix, ...rest }),
      );
    },

    async [ActionTypes.GET_PACKAGE_RETURN](
      { commit, rootState: { [LocationsNamespace]: l } },
      { suffix = l.suffix, ...rest },
    ) {
      commit(
        MutationTypes.SET_PACKAGE_RETURN,
        await PackageReturnsApiService.getPackageReturn({ suffix, ...rest }),
      );
    },
  },
};
